import { connect } from 'react-redux';
import { withTranslation } from 'react-i18next';

import FormStackSettingsBasicInfo from 'components/Forms/FormStackSettings/FormStackSettingsBasicInfo';
import { getAccount } from 'store/actions/account';

function mapStateToProps(state) {
  return {
    currentUser: state.currentUser,
    currentAccount: state.accounts.currentAccount,
  };
}
export default withTranslation()(
  connect(mapStateToProps, { getAccount })(FormStackSettingsBasicInfo),
);
